[<template>
  <div>
    <el-table
      :data="affiliate_users.data"
      :default-sort="{ prop: order_column, order: order_type }"
      @sort-change="sort"
      class="w100"
      stripe
      @expand-change="expand"
    >
      <el-table-column
        label="First name"
        prop="first_name"
        sortable
      ></el-table-column>
      <el-table-column
        label="Last name"
        prop="surname"
        sortable
      ></el-table-column>
      <el-table-column
        label="Affiliate code"
        prop="affiliate_user"
        sortable
      ></el-table-column>
      <el-table-column
        label="Affiliate URL"
      >
        <template slot-scope="props">
          {{ frontAppUrl }}/aff/{{ props.row.affiliate_user }}
        </template>
      </el-table-column>
      <el-table-column label="Affiliates" align="right">
        <template slot-scope="props">
          <el-tooltip content="Update affiliate model" placement="top">
            <el-button
              type="warning"
              class="mr5"
              circle
              size="small"
              icon="el-icon-edit"
              @click="readAffiliateModel(props.row.id)"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="Show affiliates" placement="top">
            <el-popover placement="right" width="600" trigger="click">
              <el-table :data="affiliate_customers" max-height="350" v-loading="affiliateCustomerLoading">
                <el-table-column
                  prop="first_name"
                  label="First name"
                ></el-table-column>
                <el-table-column
                  prop="surname"
                  label="Last name"
                ></el-table-column>
                <el-table-column prop="email" label="E-mail"></el-table-column>
              </el-table>
              <el-button
                type="success"
                circle
                size="small"
                icon="el-icon-user"
                slot="reference"
                @click="readAffiliateCustomers({ user: props.row.id })"
              ></el-button>
            </el-popover>
          </el-tooltip>
          <el-tooltip class="ml10" content="Export CSV" placement="top">
            <el-button
              type="primary"
              circle
              size="small"
              icon="el-icon-document"
              @click="exportCSV({ user: props.row })"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="float-right"
      background
      @size-change="sizeChange"
      @current-change="currentChange"
      :current-page.sync="affiliate_users.current_page"
      :page-sizes="[5, 10, 25, 50, 100]"
      :page-size="page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="affiliate_users.total"
    ></el-pagination>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState('affiliate', [
      'affiliate_users',
      'affiliate_customers',
      'page',
      'page_size',
      'order_column',
      'order_type',
      'affiliateCustomerLoading'
    ]),

    frontAppUrl() {
      return process.env.VUE_APP_FRONT_URL.slice(0, -1)
    }
  },

  methods: {
    ...mapActions('affiliate', [
      'readAffiliateUsers',
      'readAffiliateCustomers',
      'readAffiliateModel',
      'createAffiliate',
      'exportCSV'
    ]),
    ...mapMutations('affiliate', [
      'setPage',
      'setPageSize',
      'setOrdering',
      'setDialog'
    ]),

    sizeChange(page_size) {
      this.setPageSize(page_size)
      this.readAffiliateUsers()
    },
    currentChange(page) {
      this.setPage(page)
      this.readAffiliateUsers()
    },
    sort(d) {
      this.setOrdering({
        column: d.prop,
        type: this.ascDesc(d.order)
      })
      this.readAffiliateUsers()
    },
    expand(row, expanded) {
      // nasty hack -> close currently expanded row when another is opened
      if (expanded.length === 0) return
      const currentExpandedIcon = document.querySelector(
        '.el-table__expand-icon.el-table__expand-icon--expanded'
      )
      if (currentExpandedIcon) currentExpandedIcon.click()

      this.readAffiliateCustomers({user: row.id })
    }
  },

  created() {
    this.readAffiliateUsers()
  }
}
</script>
]
